<template>
  <div v-if="image">
    <vue-load-image>
      <img
        slot="image"
        v-bind:src="`${IMAGEURL}${image}`"
        alt=""
        class="img-responsive"
      />
    </vue-load-image>
  </div>
</template>
<script>
import VueLoadImage from "vue-load-image";

export default {
  props: {
    image: {
      type: String,
      required: true,
    },
  },
  components: {
    "vue-load-image": VueLoadImage,
  },
};
</script>
